(function () {
  'use strict';

  function showAllReveal() {
    document.querySelectorAll('.cbl-reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  // Fallback: if GSAP hasn't loaded within 4 seconds, reveal everything
  var revealTimeout = setTimeout(showAllReveal, 4000);

  function loadScript(src, cb) {
    var s = document.createElement('script');
    s.src = src;
    s.onload = cb;
    s.onerror = function () { showAllReveal(); };
    document.head.appendChild(s);
  }

  function initAnimations() {
    clearTimeout(revealTimeout);

    var gsap = window.gsap;
    var ScrollTrigger = window.ScrollTrigger;
    gsap.registerPlugin(ScrollTrigger);

    // Header scroll state
    var header = document.querySelector('.cbl-header');
    if (header) {
      var hasHero = document.querySelector('.cbl-hero');
      if (hasHero) {
        header.classList.add('cbl-header--transparent');
        ScrollTrigger.create({
          start: 'top -10',
          onUpdate: function (self) {
            if (self.progress > 0) {
              header.classList.remove('cbl-header--transparent');
              header.classList.add('cbl-header--solid');
            } else {
              header.classList.remove('cbl-header--solid');
              header.classList.add('cbl-header--transparent');
            }
          }
        });
      } else {
        header.classList.add('cbl-header--solid');
      }
    }

    // Scroll reveal for .cbl-reveal elements
    document.querySelectorAll('.cbl-reveal').forEach(function (el) {
      ScrollTrigger.create({
        trigger: el,
        start: 'top 87%',
        onEnter: function () {
          el.classList.add('is-visible');
        },
        once: true
      });
    });

    // Service/feature cards — use class toggling, not gsap.from(), to avoid opacity:0 lock
    var featureCards = document.querySelectorAll('.cbl-services-feature, .cbl-services-stack-card');
    if (featureCards.length) {
      featureCards.forEach(function (card) {
        card.style.opacity = '0';
        card.style.transform = 'translateY(32px)';
        card.style.transition = 'opacity 0.65s cubic-bezier(0.25,1,0.5,1), transform 0.65s cubic-bezier(0.25,1,0.5,1)';
      });
      ScrollTrigger.batch(featureCards, {
        start: 'top 87%',
        onEnter: function (batch) {
          batch.forEach(function (el, i) {
            setTimeout(function () {
              el.style.opacity = '1';
              el.style.transform = 'translateY(0)';
            }, i * 120);
          });
        },
        once: true
      });
    }

    // Testimonial cards stagger — same safe pattern
    var testimonialCards = document.querySelectorAll('.cbl-testimonial-card');
    if (testimonialCards.length) {
      testimonialCards.forEach(function (card) {
        card.style.opacity = '0';
        card.style.transform = 'translateY(32px)';
        card.style.transition = 'opacity 0.65s cubic-bezier(0.25,1,0.5,1), transform 0.65s cubic-bezier(0.25,1,0.5,1)';
      });
      ScrollTrigger.batch(testimonialCards, {
        start: 'top 87%',
        onEnter: function (batch) {
          batch.forEach(function (el, i) {
            setTimeout(function () {
              el.style.opacity = '1';
              el.style.transform = 'translateY(0)';
            }, i * 120);
          });
        },
        once: true
      });
    }

    // Trust bar items
    var trustItems = document.querySelectorAll('.cbl-trust-bar__item');
    if (trustItems.length) {
      trustItems.forEach(function (item) {
        item.style.opacity = '0';
        item.style.transform = 'translateY(12px)';
        item.style.transition = 'opacity 0.5s cubic-bezier(0.25,1,0.5,1), transform 0.5s cubic-bezier(0.25,1,0.5,1)';
      });
      ScrollTrigger.create({
        trigger: '.cbl-trust-bar',
        start: 'top 90%',
        onEnter: function () {
          trustItems.forEach(function (item, i) {
            setTimeout(function () {
              item.style.opacity = '1';
              item.style.transform = 'translateY(0)';
            }, i * 100);
          });
        },
        once: true
      });
    }
  }

  function init() {
    loadScript('https://cdn.jsdelivr.net/npm/gsap@3.12.7/dist/gsap.min.js', function () {
      loadScript('https://cdn.jsdelivr.net/npm/gsap@3.12.7/dist/ScrollTrigger.min.js', initAnimations);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
